'use client'
import Link from 'next/link'
import { useTranslateEntry } from 'src/i18n/client/useTranslateEntry'
import Typography from 'src/components/design-system/Typography'
import useJournalDomainRoutes from 'src/components/journals/domain/useJournalDomainRoutes'
import { buildLocalizedPath } from 'src/_helpers/localizedLinks'

export default function Keywords({ tags, id = 'keywords', variant = 'default', locale = 'en', journalUuid = null }) {
  const translate = useTranslateEntry()
  const journalRoutes = useJournalDomainRoutes()
  const searchResultsPath = buildLocalizedPath(journalRoutes.SEARCH_RESULTS, locale)

  const getTagSearchHref = (tag) => {
    const params = new URLSearchParams({ query: tag })

    if (journalUuid) {
      params.set('journalUuid', journalUuid)
    }

    return `${searchResultsPath}?${params.toString()}`
  }

  return tags.length > 0 ? (
    <div
      className={`flex flex-col ${variant === 'default' ? 'bg-dark-blue-dark-blue6 full-width-shadow-dark-blue-dark-blue6 gap-y-14 py-56' : 'gap-y-11 my-56'}`}
      id={id}
    >
      <Typography variant={variant === 'default' ? 'h2-bold' : 'h3-bold'} component="h2" color="text-basic-black">
        {translate('T_TAGS')}:
      </Typography>
      <div className="flex items-center gap-x-3 flex-wrap">
        {tags.map((tag, tagIndex) => (
          <Link key={`tag-${tagIndex}`} className="group flex gap-x-3 cursor-pointer" href={getTagSearchHref(tag)}>
            <Typography
              variant="h3-light"
              component="span"
              color="text-dark-blue-dark-blue8"
              className="block w-fit h-fit relative after:content-[''] after:h-1 after:w-full after:transition-[width] after:absolute after:bottom-0 after:left-0 group-hover:after:w-0 after:bg-[currentColor]"
            >
              {tag}
            </Typography>
            {tagIndex < tags.length - 1 && (
              <Typography variant="h3-light" component="span" color="text-basic-black">
                ,
              </Typography>
            )}
          </Link>
        ))}
      </div>
    </div>
  ) : null
}
